import React, { useState } from "react";
import Footer from '../../components/Footer';
import "./styles.css";
import { useNavigate } from 'react-router-dom';

import FigmaLogo from '../../images/homepage/figmaLogo.png';
import NotionLogo from '../../images/homepage/notionLogo.png';
import MicrosoftAzureLogo from '../../images/homepage/microsoftAzureLogo.png';
import MongoDBLogo from '../../images/homepage/mongoDBLogo.png';

function StarterPack() {
  let navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [selectedOffer, setSelectedOffer] = useState(null);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const offers = [
    {
      id: 1,
      company: "Figma",
      logo: FigmaLogo,
      description: "Professional design and collaboration tools used by industry leaders. Create graphics, presentations, prototypes, and more.",
      offer: "100% free access to Figma Professional tier for students and educators",
      value: "Free",
      couponsRemaining: true,
      redemptionSteps: [
        "Click Redeem to visit Figma Education",
        "Sign up with your student or teacher email address",
        "Verify your education status",
        "Get free access to all professional paid tools"
      ],
      email: "education@figma.com",
      eligibility: "Students and educators with valid school email",
      link: "https://www.figma.com/education/"
    },
    {
      id: 2,
      company: "Notion",
      logo: NotionLogo,
      description: "The all-in-one workspace. Write. Plan. Collaborate. Organize your schoolwork, clubs, and projects.",
      offer: "Free Plus plan with unlimited pages, blocks, and 30-day version history",
      value: "Free",
      couponsRemaining: true,
      redemptionSteps: [
        "Click Redeem to visit Notion for Education",
        "Sign in with your school email address",
        "Go to Settings and select 'Get free education plan'",
        "Enjoy unlimited storage and premium features"
      ],
      email: "team@makenotion.com",
      eligibility: "Students and educators at accredited colleges and universities",
      link: "https://www.notion.com/product/notion-for-education"
    },
    {
      id: 3,
      company: "Microsoft Azure",
      logo: MicrosoftAzureLogo,
      description: "Build in the cloud with Azure's powerful services. Develop apps, explore AI, and work with big data.",
      offer: "$100 Azure credit + free services for 12 months (no credit card required)",
      value: "$100",
      couponsRemaining: true,
      redemptionSteps: [
        "Click Redeem to visit Azure for Students",
        "Use your university or school email to sign up",
        "Get $100 credit to use in 12 months",
        "Access free services including VMs, SQL Database, and more",
        "Renew each year you're a student"
      ],
      email: "azure-students@microsoft.com",
      eligibility: "College and university students with valid school email",
      link: "https://azure.microsoft.com/en-in/free/students/"
    },
    {
      id: 4,
      company: "MongoDB",
      logo: MongoDBLogo,
      description: "The leading modern, general purpose database platform. Build faster with flexible documents and powerful queries.",
      offer: "Free certification + $50 Atlas credit via GitHub Student Developer Pack",
      value: "$50",
      couponsRemaining: true,
      redemptionSteps: [
        "Click Redeem to visit MongoDB for Students",
        "Sign up for the GitHub Student Developer Pack if you haven't already",
        "Access MongoDB through the pack",
        "Get free certification courses",
        "Redeem your $50 of Atlas credit"
      ],
      email: "students@mongodb.com",
      eligibility: "Students with GitHub Student Developer Pack",
      link: "https://www.mongodb.com/students"
    }
  ];

  const openModal = (offer) => {
    setSelectedOffer(offer);
  };

  const closeModal = () => {
    setSelectedOffer(null);
  };

  return (
    <>
      <div className="starter-pack-container">
        {/* Hero Section */}
        <div className="starter-pack-hero">
          <div className="starter-pack-hero-content">
            <h1 className="starter-pack-title">
              Nora AI Starter Pack
            </h1>
            <p className="starter-pack-subtitle">
              Exclusive discounts and credits to build projects, learn new skills, and land your dream job. Everything you need to succeed in your job hunt.
            </p>
          </div>
        </div>

        {/* Offers Grid */}
        <div className="offers-grid">
          {offers.map((offer) => (
            <div key={offer.id} className="offer-card">
              <div className="offer-card-header">
                <div className="offer-company-info">
                  <div className="offer-logo">
                    <img src={offer.logo} alt={`${offer.company} logo`} />
                  </div>
                  <div>
                    <h3 className="offer-company-name">{offer.company}</h3> 
                    {!offer.couponsRemaining && (
                      <span className="no-coupons">No coupons remaining</span>
                    )}
                  </div>
                </div>
                <button 
                  className={`redeem-button ${!offer.couponsRemaining ? 'disabled' : ''}`}
                  onClick={() => openModal(offer)}
                  disabled={!offer.couponsRemaining}
                >
                  {offer.couponsRemaining ? 'Redeem' : 'Unavailable'}
                </button>
              </div>

              <p className="offer-description">{offer.description}</p>

              <div className="offer-details">
                <div className="offer-value-badge">
                  <span className="offer-value">{offer.offer}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Modal */}
        {selectedOffer && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content2" onClick={(e) => e.stopPropagation()}>
              <button className="modal-close2" onClick={closeModal}>×</button>
              
              <div className="modal-header">
                <div className="modal-logo">
                  <img src={selectedOffer.logo} alt={`${selectedOffer.company} logo`} />
                </div>
                <h2>{selectedOffer.company}</h2>
              </div>

              <div className="modal-body">
                <h3>To redeem the offer:</h3>
                <ol className="redemption-steps">
                  {selectedOffer.redemptionSteps.map((step, index) => (
                    <li key={index}>
                      {step.includes('Redeem') ? (
                        <>
                          Click <strong>Redeem</strong> {step.split('Redeem')[1]}
                        </>
                      ) : (
                        step
                      )}
                    </li>
                  ))}
                </ol>

                <div className="modal-info">
                  <p><strong>Eligibility:</strong> {selectedOffer.eligibility}</p>
                  <p><strong>Questions?</strong> Email {' '}
                    <a href={`mailto:${selectedOffer.email}`}>{selectedOffer.email}</a>
                  </p>
                </div>

                <button 
                  className="modal-redeem-button"
                  onClick={() => window.open(selectedOffer.link, '_blank')}
                >
                  Redeem <span className="external-icon">↗</span>
                </button>
              </div>
            </div>
          </div>
        )}

        <Footer />
      </div>
    </>
  );
}

export default StarterPack;